/* F8 — disclosure desktop, acordeões e combobox F4; eventos delegados para o editor. */
(function () {
  'use strict';

  if (window.HitCabecalho) return;
  window.HitCabecalho = true;

  var DESK = window.matchMedia('(min-width:900px)');
  var REDUZIDO = window.matchMedia('(prefers-reduced-motion:reduce)');

  function cab() { return document.getElementById('cab'); }

  /* ---------- 1. compacto com a rolagem ----------
     Entra ao passar de ENTRA px e só sai abaixo de SAI px: entre os dois, fica como está. A altura que o cabeçalho perde volta como
     margem (css), então o resto da página não anda e a rolagem não se refaz. Com a gaveta aberta o corpo vira position:fixed e scrollY
     vale 0: nesse caso o estado fica como estava. */
  var ENTRA = 80;
  var SAI = 24;
  var quadroCompacto = false;

  function atualizarCompacto() {
    quadroCompacto = false;
    var c = cab();
    if (!c || document.body.style.position === 'fixed') return;
    var y = window.scrollY;
    var compacto = c.classList.contains('compacto');
    if (!compacto && y > ENTRA) c.classList.add('compacto');
    else if (compacto && y < SAI) c.classList.remove('compacto');
  }

  /* ---------- 6. WhatsApp flutuante ---------- */
  var quadroWa = false;
  var MARGEM_WA = 8;

  function cruza(a, b, m) {
    return a.left < b.right + m && a.right > b.left - m && a.top < b.bottom + m && a.bottom > b.top - m;
  }

  function medirWa() {
    quadroWa = false;
    var wa = document.querySelector('.wa');
    if (!wa) return;
    var recua = false;
    // celular: o css já põe o botão acima da barra de compra (--barh); só o computador tem a barra solta no meio da página
    if (DESK.matches) {
      var r = wa.getBoundingClientRect();
      var alvos = document.querySelectorAll('#compra, [data-wa-evita]');
      for (var i = 0; i < alvos.length && !recua; i += 1) {
        var a = alvos[i].getBoundingClientRect();
        if (a.width > 0 && a.height > 0 && cruza(r, a, MARGEM_WA)) recua = true;
      }
    }
    wa.classList.toggle('wa-recua', recua);
  }

  function aoRolar() {
    if (!quadroCompacto) { quadroCompacto = true; window.requestAnimationFrame(atualizarCompacto); }
    if (!quadroWa) { quadroWa = true; window.requestAnimationFrame(medirWa); }
  }

  /* ---------- 2. faixa de avisos ----------
     Uma mensagem por vez, troca a cada TROCA_MS. Para sozinha com o mouse em cima, o foco dentro ou o dedo na faixa, e volta ao sair.
     Depois de usar uma seta (ou o botão Pausar) só volta pelo botão Retomar. Com movimento reduzido, nunca gira sozinha. Uma mensagem só:
     sem setas, sem botão e sem giro. A contagem (data-contagem) nasce hidden e só aparece dentro da janela início/fim; depois do fim some.
     aria-live fica "off" enquanto gira sozinha e "polite" quando parada, para quem usa leitor de tela ouvir só o que escolheu. */
  var TROCA_MS = 5000;
  var CONTAGEM_MS = 10000;
  var ZONA_PADRAO = '-03:00'; // Brasília: data sem fuso é lida assim, não no relógio do aparelho
  var faixas = new WeakMap(); // [data-util] -> { mostrar(msg) }

  // "2026-11-27T00:00:00-03:00" -> milissegundos; sem hora vira 00:00, sem fuso vira Brasília; inválido -> NaN.
  // Data impossível (31/11, 30/02, mês 13, 25h) também é NaN: o Date.parse do navegador a "arruma" (31/11 vira 01/12) e a contagem mentiria.
  function lerData(txt) {
    var t = String(txt || '').trim().replace(' ', 'T');
    if (!/^\d{4}-\d{2}-\d{2}/.test(t)) return NaN;
    if (t.length === 10) t += 'T00:00:00';
    if (/T\d{2}:\d{2}$/.test(t)) t += ':00';
    if (/[+-]\d{4}$/.test(t)) t = t.replace(/(\d{2})$/, ':$1'); // -0300 -> -03:00 (o Safari exige os dois pontos)
    if (!/(Z|[+-]\d{2}:?\d{2})$/.test(t)) t += ZONA_PADRAO;
    return existe(t) ? Date.parse(t) : NaN;
  }

  // ida e volta: monta a data com os números escritos e confere que o calendário devolve os mesmos números
  function existe(t) {
    var p = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2}):(\d{2}))?/.exec(t);
    if (!p) return false;
    var n = [+p[1], +p[2], +p[3], +p[4] || 0, +p[5] || 0, +p[6] || 0];
    var d = new Date(Date.UTC(n[0], n[1] - 1, n[2], n[3], n[4], n[5]));
    return d.getUTCFullYear() === n[0] && d.getUTCMonth() === n[1] - 1 && d.getUTCDate() === n[2] &&
      d.getUTCHours() === n[3] && d.getUTCMinutes() === n[4] && d.getUTCSeconds() === n[5];
  }

  // minutos inteiros que faltam, arredondados para cima: "3d 4h 25min", "4h 25min", "25min"
  function formatarFalta(ms) {
    var m = Math.max(1, Math.ceil(ms / 60000));
    var d = Math.floor(m / 1440), h = Math.floor((m % 1440) / 60), mi = m % 60, p = [];
    if (d) p.push(d + 'd');
    if (d || h) p.push(h + 'h');
    p.push(mi + 'min');
    return p.join(' ');
  }

  // true quando a contagem deve aparecer agora; escreve o texto só se mudou (o leitor de tela não repete o que não mudou)
  function atualizarContagem(msg) {
    var fim = lerData(msg.getAttribute('data-fim'));
    var inicio = lerData(msg.getAttribute('data-inicio'));
    var agora = Date.now();
    var rotulo = msg.querySelector('[data-util-rotulo]');
    var tempo = msg.querySelector('[data-util-tempo]');
    if (isNaN(fim) || agora >= fim || (!isNaN(inicio) && inicio >= fim) || !rotulo || !tempo) return false;
    var antes = !isNaN(inicio) && agora < inicio;
    var texto = msg.getAttribute(antes ? 'data-antes' : 'data-durante') || '';
    var falta = formatarFalta((antes ? inicio : fim) - agora);
    if (rotulo.textContent !== texto) rotulo.textContent = texto;
    if (tempo.textContent !== falta) tempo.textContent = falta;
    return true;
  }

  function montarFaixa(raiz) {
    var faixa = raiz.closest('.util') || raiz;
    var msgs = Array.prototype.slice.call(raiz.querySelectorAll('[data-util-msg]'));
    var ant = raiz.querySelector('[data-util-ant]');
    var prox = raiz.querySelector('[data-util-prox]');
    var pausa = raiz.querySelector('[data-util-pausa]');
    var ativa = null, timer = 0, manual = false, sobre = false, foco = false, toque = false;

    function visiveis() { return msgs.filter(function (m) { return !m.hidden; }); }
    function girando() { return visiveis().length > 1 && !manual && !sobre && !foco && !toque && !document.hidden && !REDUZIDO.matches; }

    function marcar(m) {
      ativa = m;
      msgs.forEach(function (x) { if (x === m) x.setAttribute('data-ativo', ''); else x.removeAttribute('data-ativo'); });
    }
    function andar(delta) {
      var lista = visiveis();
      if (!lista.length) return;
      var i = lista.indexOf(ativa);
      marcar(lista[i < 0 ? 0 : (i + delta + lista.length) % lista.length]);
    }
    function rotuloPausa() { pausa.textContent = manual ? 'Retomar rotação dos avisos' : 'Pausar rotação dos avisos'; }

    // parou: apaga o relógio; girando: mantém o que está correndo (o tique da contagem não pode atrasar a troca) ou começa um novo
    function agendar() {
      if (!document.body.contains(raiz)) { window.clearTimeout(timer); return; } // a seção foi recarregada no editor
      var gira = girando();
      raiz.setAttribute('aria-live', gira ? 'off' : 'polite');
      if (!gira) { window.clearTimeout(timer); timer = 0; return; }
      if (!timer) timer = window.setTimeout(function () { timer = 0; andar(1); agendar(); }, TROCA_MS);
    }

    // mostra ou esconde as contagens, escolhe a mensagem ativa e liga ou desliga os controles
    function atualizar() {
      msgs.forEach(function (m) { if (m.hasAttribute('data-contagem')) m.hidden = !atualizarContagem(m); });
      var lista = visiveis();
      faixa.hidden = !lista.length;
      if (lista.indexOf(ativa) < 0) marcar(lista[0] || null);
      var varios = lista.length > 1;
      ant.hidden = prox.hidden = !varios;
      pausa.hidden = !varios || REDUZIDO.matches;
      rotuloPausa();
      agendar();
    }

    function parar(delta) { manual = true; andar(delta); atualizar(); }

    faixa.setAttribute('data-pronto', '');
    ant.addEventListener('click', function () { parar(-1); });
    prox.addEventListener('click', function () { parar(1); });
    pausa.addEventListener('click', function () { manual = !manual; atualizar(); });
    raiz.addEventListener('pointerenter', function (ev) { if (ev.pointerType === 'mouse') { sobre = true; agendar(); } });
    raiz.addEventListener('pointerleave', function (ev) { if (ev.pointerType === 'mouse') { sobre = false; agendar(); } });
    raiz.addEventListener('touchstart', function () { toque = true; agendar(); }, { passive: true });
    ['touchend', 'touchcancel'].forEach(function (nome) { raiz.addEventListener(nome, function () { toque = false; agendar(); }, { passive: true }); });
    raiz.addEventListener('focusin', function () { foco = true; agendar(); });
    raiz.addEventListener('focusout', function (ev) { if (!raiz.contains(ev.relatedTarget)) { foco = false; agendar(); } });
    document.addEventListener('visibilitychange', agendar);
    REDUZIDO.addEventListener('change', atualizar);
    if (msgs.some(function (m) { return m.hasAttribute('data-contagem'); })) {
      var relogio = window.setInterval(function () {
        if (!document.body.contains(raiz)) { window.clearInterval(relogio); return; }
        atualizar();
      }, CONTAGEM_MS);
    }
    faixas.set(raiz, { mostrar: function (m) { if (m.hidden) return; manual = true; marcar(m); atualizar(); } });
    atualizar();
  }

  function iniciarFaixa() {
    document.querySelectorAll('[data-util]').forEach(function (raiz) {
      if (!faixas.has(raiz)) montarFaixa(raiz);
    });
  }

  /* ---------- 5. busca preditiva ---------- */
  var MIN_LETRAS = 2;
  var ESPERA_MS = 250;
  var LIMITE_CACHE = 30;
  var textoCache = new Map();   // termo -> HTML que a Shopify devolveu
  var estados = new WeakMap();  // formulário -> { n, timer, ctrl, ativo, tentou429 }
  var contador = 0;

  var DICA_SR = 'Resultados da busca disponíveis. Use as setas para cima e para baixo e Enter para abrir.';
  var FALHA_SR = 'A busca rápida não respondeu. Aperte Enter para buscar na página de resultados.';

  function parteDe(form, seletor) { return form.querySelector(seletor); }
  function campoDe(form) { return parteDe(form, '[data-busca-input]'); }
  function listaDe(form) { return parteDe(form, '[data-busca-lista]'); }
  function painelDe(form) { return parteDe(form, '.busca-res'); }
  function opcoesDe(form) {
    var l = listaDe(form);
    return l ? Array.prototype.slice.call(l.querySelectorAll('[role="option"]')) : [];
  }

  // ids nascem aqui, não no HTML: a gaveta copia o mesmo modelo a cada abertura e dois formulários não podem repetir id
  function estadoDe(form) {
    var e = estados.get(form);
    if (e) return e;
    contador += 1;
    e = { n: contador, timer: 0, ctrl: null, ativo: -1, tentou429: '' };
    estados.set(form, e);
    var lista = listaDe(form);
    var campo = campoDe(form);
    if (lista) lista.id = 'busca-' + e.n + '-lista';
    if (lista && campo) campo.setAttribute('aria-controls', lista.id);
    return e;
  }

  function falar(form, texto) {
    var s = parteDe(form, '[data-busca-status]');
    if (s) s.textContent = texto || '';
  }

  function ativar(form, i) {
    var e = estadoDe(form);
    var ops = opcoesDe(form);
    var campo = campoDe(form);
    if (e.ativo >= 0 && ops[e.ativo]) ops[e.ativo].setAttribute('aria-selected', 'false');
    e.ativo = i;
    if (i >= 0 && ops[i]) {
      ops[i].setAttribute('aria-selected', 'true');
      campo.setAttribute('aria-activedescendant', ops[i].id);
      ops[i].scrollIntoView({ block: 'nearest' });
    } else {
      campo.removeAttribute('aria-activedescendant');
    }
  }

  function listaAberta(form) {
    var p = painelDe(form);
    return !!p && !p.hidden;
  }

  function abrirLista(form) {
    var p = painelDe(form);
    var campo = campoDe(form);
    if (!p || !campo) return;
    fecharDesktop(false);
    p.hidden = false;
    campo.setAttribute('aria-expanded', 'true');
    form.setAttribute('data-buscando', '');
    var nav = form.parentElement.querySelector('.menu-mobile');
    if (nav) nav.hidden = true;
  }

  function cancelar(form) {
    var e = estadoDe(form);
    window.clearTimeout(e.timer);
    if (e.ctrl) { e.ctrl.abort(); e.ctrl = null; }
  }

  function fecharLista(form) {
    var p = painelDe(form);
    var campo = campoDe(form);
    if (!p || !campo) return;
    if (p.hidden && !form.hasAttribute('data-buscando')) return;
    cancelar(form);
    ativar(form, -1);
    p.hidden = true;
    campo.setAttribute('aria-expanded', 'false');
    form.removeAttribute('data-buscando');
    var nav = form.parentElement.querySelector('.menu-mobile');
    if (nav) nav.hidden = false;
    falar(form, '');
  }

  function montarUrl(form, termo) {
    var base = form.getAttribute('data-url') || '/search/suggest';
    return base + '?q=' + encodeURIComponent(termo) +
      '&section_id=predictive-search&resources[type]=query,collection,product&resources[limit]=4' +
      '&resources[limit_scope]=each&resources[options][unavailable_products]=last';
  }

  // põe o que a seção devolveu no listbox que já existe: opções dentro dele, aviso de "sem resultado" fora (listbox só tem opções)
  function pintar(form, termo, html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var lista = listaDe(form);
    var vazio = parteDe(form, '[data-busca-vazio]');
    var vinda = doc.querySelector('.bp-lista');
    if (!lista || !vinda) { fecharLista(form); return; }
    var e = estadoDe(form);

    ativar(form, -1);
    lista.replaceChildren.apply(lista, Array.prototype.map.call(vinda.childNodes, function (n) { return document.importNode(n, true); }));
    lista.setAttribute('data-termo', termo);
    opcoesDe(form).forEach(function (o, i) {
      o.id = 'busca-' + e.n + '-o' + i;
      o.setAttribute('aria-selected', 'false');
    });

    var aviso = doc.querySelector('.bp-vazio');
    if (vazio) {
      vazio.textContent = aviso ? aviso.textContent : '';
      vazio.hidden = !aviso;
    }
    abrirLista(form);
    falar(form, aviso ? aviso.textContent : DICA_SR);
  }

  function lembrar(termo, html) {
    if (textoCache.size >= LIMITE_CACHE) textoCache.delete(textoCache.keys().next().value);
    textoCache.set(termo, html);
  }

  function buscar(form, termo) {
    var e = estadoDe(form);
    var campo = campoDe(form);
    if (textoCache.has(termo)) { pintar(form, termo, textoCache.get(termo)); return; }
    if (e.ctrl) e.ctrl.abort();
    var ctrl = new AbortController();
    e.ctrl = ctrl;

    fetch(montarUrl(form, termo), { signal: ctrl.signal, headers: { Accept: 'text/html' }, credentials: 'same-origin' })
      .then(function (r) {
        if (r.status === 429) {
          // limite de pedidos da Shopify: espera o tempo que ela mandou (padrão 3 s, no máximo 10) e tenta o mesmo termo uma vez
          var s = parseInt(r.headers.get('Retry-After'), 10);
          var erro = new Error('limite');
          erro.espera = Math.min(Math.max(s > 0 ? s : 3, 1), 10) * 1000;
          throw erro;
        }
        if (!r.ok) throw new Error('busca ' + r.status);
        return r.text();
      })
      .then(function (html) {
        if (e.ctrl === ctrl) e.ctrl = null;
        lembrar(termo, html);
        // o texto pode ter mudado enquanto a resposta vinha
        if (campo.value.trim() === termo) pintar(form, termo, html);
      })
      .catch(function (erro) {
        if (erro && erro.name === 'AbortError') return;
        if (e.ctrl === ctrl) e.ctrl = null;
        if (erro && erro.espera && e.tentou429 !== termo) {
          e.tentou429 = termo;
          e.timer = window.setTimeout(function () { if (campo.value.trim() === termo) buscar(form, termo); }, erro.espera);
          return;
        }
        fecharLista(form);
        falar(form, FALHA_SR);
      });
  }

  function aoDigitar(campo) {
    var form = campo.closest('[data-busca]');
    if (!form) return;
    var termo = campo.value.trim();
    cancelar(form);
    if (termo.length < MIN_LETRAS) { fecharLista(form); return; }
    estadoDe(form).timer = window.setTimeout(function () { buscar(form, termo); }, ESPERA_MS);
  }

  function aoTeclarBusca(ev, campo) {
    var form = campo.closest('[data-busca]');
    if (!form) return;
    var e = estadoDe(form);
    var ops = opcoesDe(form);
    var aberta = listaAberta(form);

    if (ev.key === 'ArrowDown' || ev.key === 'ArrowUp') {
      // lista fechada com resultados do mesmo texto guardados: a seta a reabre; sem eles, a seta não faz nada
      var lista = listaDe(form);
      if (!aberta) {
        if (ops.length && lista.getAttribute('data-termo') === campo.value.trim()) abrirLista(form);
        else return;
      }
      ev.preventDefault();
      var n = ops.length;
      if (!n) return;
      var prox = ev.key === 'ArrowDown' ? e.ativo + 1 : e.ativo - 1;
      if (prox >= n) prox = 0;
      if (prox < 0) prox = n - 1;
      ativar(form, prox);
    } else if (ev.key === 'Enter') {
      // com uma opção ativa, Enter a abre; sem ela, o formulário envia para a página de resultados
      if (aberta && e.ativo >= 0 && ops[e.ativo]) { ev.preventDefault(); ops[e.ativo].click(); }
    }
  }

  /* ---------- teclado: Esc (fase de captura, antes do HitCamadas, que respeita defaultPrevented) ---------- */
  document.addEventListener('keydown', function (ev) {
    var alvo = ev.target;
    if (!alvo || !alvo.closest) return;

    if (ev.key === 'Escape') {
      var form = alvo.closest('[data-busca]');
      if (form && listaAberta(form)) {
        // primeiro Esc fecha só a lista; o campo, a linha do celular e a gaveta ficam como estão
        ev.preventDefault();
        fecharLista(form);
        return;
      }
      return;
    }

    if (alvo.matches('[data-busca-input]')) aoTeclarBusca(ev, alvo);
  }, true);

  document.addEventListener('input', function (ev) {
    if (ev.target.matches && ev.target.matches('[data-busca-input]')) aoDigitar(ev.target);
  });

  // foco de volta no campo com resultados do mesmo texto: reabre a lista
  document.addEventListener('focusin', function (ev) {
    var alvo = ev.target;
    if (!alvo || !alvo.closest) return;
    if (alvo.matches('[data-busca-input]')) {
      fecharDesktop(false);
      var form = alvo.closest('[data-busca]');
      var lista = form && listaDe(form);
      if (lista && !listaAberta(form) && lista.children.length && lista.getAttribute('data-termo') === alvo.value.trim()) abrirLista(form);
    }
    if (aberto && !aberto.contains(alvo)) fecharDesktop(false);
  });

  // foco que sai do formulário fecha a lista (com um tick de espera: o foco novo ainda não chegou no focusout)
  document.addEventListener('focusout', function (ev) {
    var alvo = ev.target;
    var form = alvo && alvo.closest && alvo.closest('[data-busca]');
    if (!form) return;
    window.setTimeout(function () {
      if (!form.contains(document.activeElement)) fecharLista(form);
    }, 0);
  });

  // clicar numa opção não pode tirar o foco do campo antes do clique chegar
  document.addEventListener('mousedown', function (ev) {
    if (ev.target.closest && ev.target.closest('.busca-res')) ev.preventDefault();
  });

  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form.matches || !form.matches('[data-busca]')) return;
    var campo = campoDe(form);
    if (campo && campo.value.trim() === '') { ev.preventDefault(); campo.focus(); }
  });

  document.addEventListener('click', function (ev) {
    var alvo = ev.target;
    if (!alvo || !alvo.closest) return;

    document.querySelectorAll('[data-busca]').forEach(function (f) {
      if (!f.contains(alvo)) { cancelar(f); fecharLista(f); }
    });
  });

  /* ---------- menu: conteúdo, disclosure e acordeões ---------- */
  var aberto = null, aberturaY = 0, timerAbrir = 0, timerFechar = 0;
  var bloqueadoHover = new WeakSet();
  var PONTEIRO = window.matchMedia('(hover:hover) and (pointer:fine)');
  function gatilho(item) { return item && item.querySelector('.menu-gatilho'); }
  function painel(item) { return item && item.querySelector('.menu-painel'); }
  function cancelarTimers() { clearTimeout(timerAbrir); clearTimeout(timerFechar); }
  function fecharItem(item, foco) {
    var b = gatilho(item), p = painel(item);
    if (!b || !p) return;
    p.hidden = true;
    b.setAttribute('aria-expanded', 'false');
    if (foco) b.focus({ preventScroll: true });
    if (item === aberto) aberto = null;
  }
  function fecharDesktop(foco, bloquear) {
    cancelarTimers();
    if (!aberto) return;
    var item = aberto;
    if (bloquear) bloqueadoHover.add(item);
    fecharItem(item, foco && painel(item).contains(document.activeElement));
  }
  function medirPainel() {
    if (cab()) cab().style.setProperty('--menu-bottom', cab().getBoundingClientRect().bottom + 'px');
  }
  function alternar(item, hover) {
    var b = gatilho(item), p = painel(item);
    if (!b || !p) return;
    cancelarTimers();
    var eraAberto = !p.hidden;
    var desktop = !!item.closest('#cab');
    if (desktop) {
      if (aberto && aberto !== item) fecharDesktop(false);
      document.querySelectorAll('[data-busca]').forEach(function (f) { cancelar(f); fecharLista(f); });
    } else {
      item.closest('.menu-lista').querySelectorAll('.menu-item').forEach(function (outro) {
        if (outro !== item) fecharItem(outro, false);
      });
    }
    if (eraAberto && !hover) {
      bloqueadoHover.add(item);
      fecharItem(item, false);
      return;
    }
    p.hidden = false;
    b.setAttribute('aria-expanded', 'true');
    if (desktop) { aberto = item; aberturaY = window.scrollY; medirPainel(); }
    else {
      var corpo = item.closest('.g-corpo');
      var r = b.getBoundingClientRect(), c = corpo.getBoundingClientRect();
      if (r.top < c.top) corpo.scrollTop += r.top - c.top;
      else if (r.bottom > c.bottom) corpo.scrollTop += r.bottom - c.bottom;
    }
  }
  function marcarAtual() {
    document.querySelectorAll('#cab a[href], #gaveta[data-gaveta-aberta="menu"] a[href], .menu-sem-js a[href]').forEach(function (a) {
      var u = new URL(a.href, location.href);
      var relevantes = function (url) {
        return [...url.searchParams].filter(function (par) { return par[0] === 'q' || par[0] === 'type' || par[0] === 'sort_by' || par[0].startsWith('filter.'); }).sort().toString();
      };
      var atual = new URL(location.href);
      a.removeAttribute('aria-current');
      if (u.origin === atual.origin && u.pathname === atual.pathname && relevantes(u) === relevantes(atual)) a.setAttribute('aria-current', 'page');
    });
  }
  function registrarMenu() {
    if (!window.HitGaveta) return;
    window.HitGaveta.registrar('menu', function () {
      var t = document.getElementById('gav-menu'), pe = document.getElementById('gav-menu-pe');
      if (!t) return null;
      return { titulo: 'Menu', corpo: t.content.cloneNode(true), pe: pe && pe.content.cloneNode(true) };
    });
  }
  function viewportMenu() {
    var g = document.querySelector('#gaveta[data-gaveta-aberta="menu"]');
    if (g) g.style.setProperty('--menu-viewport', (window.visualViewport ? window.visualViewport.height : window.innerHeight) + 'px');
  }
  function conferirLogo(imagem) {
    if (!imagem.matches || !imagem.matches('.menu-marca-logo')) return;
    var texto = imagem.parentElement.querySelector('.menu-marca-nome');
    if (!texto) return;
    var carregou = imagem.complete && imagem.naturalWidth > 0;
    imagem.hidden = imagem.complete && !carregou;
    texto.hidden = carregou;
  }
  function conferirLogos() {
    document.querySelectorAll('.menu-marca-logo').forEach(conferirLogo);
  }
  document.addEventListener('load', function (ev) { conferirLogo(ev.target); }, true);
  document.addEventListener('error', function (ev) { conferirLogo(ev.target); }, true);
  if (window.visualViewport) window.visualViewport.addEventListener('resize', viewportMenu);
  document.addEventListener('hit:camada-abriu', function () {
    fecharDesktop(false, true);
    var g = document.querySelector('#gaveta[data-gaveta-aberta="menu"]');
    if (!g) return;
    viewportMenu();
    conferirLogos();
    marcarAtual();
    g.querySelectorAll('[data-busca]').forEach(estadoDe);
  });
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('.menu-gatilho');
    if (b) alternar(b.closest('.menu-item'), false);
    var fechar = ev.target.closest && ev.target.closest('.menu-fechar');
    if (fechar) {
      var item = fechar.closest('.menu-item');
      cancelarTimers(); bloqueadoHover.add(item); fecharItem(item, true);
    }
  });
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Escape' || ev.defaultPrevented) return;
    var item = ev.target.closest && ev.target.closest('.menu-item');
    if (item && painel(item) && !painel(item).hidden) {
      ev.preventDefault(); cancelarTimers(); bloqueadoHover.add(item); fecharItem(item, true);
    }
  }, true);
  document.addEventListener('pointerover', function (ev) {
    if (!DESK.matches || !PONTEIRO.matches || ev.pointerType === 'touch') return;
    var item = ev.target.closest && ev.target.closest('#cab .menu-item');
    if (!item || !gatilho(item)) return;
    if (!item.contains(ev.relatedTarget)) clearTimeout(timerFechar);
    var b = ev.target.closest('.menu-gatilho');
    if (!b || b.contains(ev.relatedTarget) || bloqueadoHover.has(item)) return;
    clearTimeout(timerAbrir);
    timerAbrir = setTimeout(function () { alternar(item, true); }, 180);
  });
  document.addEventListener('pointerout', function (ev) {
    var item = ev.target.closest && ev.target.closest('#cab .menu-item');
    if (!item || item.contains(ev.relatedTarget)) return;
    bloqueadoHover.delete(item);
    clearTimeout(timerAbrir);
    clearTimeout(timerFechar);
    timerFechar = setTimeout(function () {
      if (aberto === item && !item.contains(document.activeElement)) fecharDesktop(false);
    }, 240);
  });
  document.addEventListener('focusout', function (ev) {
    var item = ev.target.closest && ev.target.closest('#cab .menu-item');
    if (!item) return;
    setTimeout(function () { if (aberto === item && !item.contains(document.activeElement)) fecharDesktop(false); }, 0);
  });
  document.addEventListener('pointerdown', function (ev) {
    if (!aberto || aberto.contains(ev.target)) return;
    var anterior = aberto, tinhaFoco = painel(anterior).contains(document.activeElement);
    fecharDesktop(false, true);
    // O clique externo escolhe seu próprio foco; só recupera um foco ainda preso na região oculta.
    setTimeout(function () { if (tinhaFoco && painel(anterior).contains(document.activeElement)) gatilho(anterior).focus({ preventScroll: true }); }, 0);
  });
  document.addEventListener('shopify:block:select', function (ev) {
    var item = ev.target.closest && ev.target.closest('#cab .menu-item');
    if (!item && cab()) item = [...cab().querySelectorAll('.menu-item')].find(function (x) { return x.querySelector('[data-shopify-editor-block*="' + ev.detail.blockId + '"]'); });
    if (item && gatilho(item) && painel(item).hidden) alternar(item, false);
  });
  // no editor, selecionar um bloco de aviso mostra e segura aquela mensagem
  document.addEventListener('shopify:block:select', function (ev) {
    var msg = ev.target.closest && ev.target.closest('[data-util-msg]');
    var faixa = msg && faixas.get(msg.closest('[data-util]'));
    if (faixa) faixa.mostrar(msg);
  });
  // O script do cabeçalho precede os módulos de camada no HTML; todos existem em DOMContentLoaded.
  document.addEventListener('DOMContentLoaded', registrarMenu);

  /* ---------- partida ---------- */
  function iniciar() {
    fecharDesktop(false);
    registrarMenu();
    iniciarFaixa();
    atualizarCompacto();
    medirWa();
    marcarAtual();
    conferirLogos();
    document.querySelectorAll('[data-busca]').forEach(estadoDe);
  }
  window.addEventListener('scroll', function () {
    aoRolar();
    if (aberto && Math.abs(window.scrollY - aberturaY) >= 16) fecharDesktop(true, true);
  }, { passive: true });
  window.addEventListener('resize', function () { aoRolar(); medirPainel(); }, { passive: true });
  function aoMudarTela() {
    var ativo = document.activeElement;
    var item = ativo && ativo.closest('[data-menu-item]');
    var chave = item && item.dataset.menuItem;
    var eraMenu = document.querySelector('#gaveta[data-gaveta-aberta="menu"].on');
    fecharDesktop(false);
    document.querySelectorAll('[data-busca]').forEach(function (f) { cancelar(f); fecharLista(f); });
    if (eraMenu && DESK.matches) window.HitGaveta.fechar();
    if (item || eraMenu) {
      var equivalente = DESK.matches && chave && cab().querySelector('[data-menu-item="' + chave + '"] .menu-gatilho');
      var destino = equivalente || (!DESK.matches && cab().querySelector('.lojab')) || cab().querySelector('.logo');
      destino.focus({ preventScroll: true });
    }
    medirWa();
  }
  DESK.addEventListener('change', aoMudarTela);
  document.addEventListener('shopify:section:load', iniciar);
  // página guardada pelo navegador (voltar): fecha o que ficou aberto
  window.addEventListener('pageshow', function (ev) {
    if (!ev.persisted) return;
    fecharDesktop(false);
    document.querySelectorAll('[data-busca]').forEach(fecharLista);
  });

  iniciar();
})();
